import reducer from "./reducers";

import * as companiesActions from "./actions";

export { companiesActions };

export default reducer;
